import React from "react";
import { Col, Row } from "reactstrap";
import { getFieldsReportForm } from "../../../sims/appFormReportsUtility";
function arrayMethod(testSched) {
  let data = [];
  let table = testSched && testSched.formData && testSched.formData.find((field) => field && field.type === "table");
  if (table && table.value) {
    data = getFieldsReportForm(table.value);
  }
  return data;
}

export const genericTableSection = (tests) => {
  let returnData = [];
  returnData =
    tests &&
    tests.length > 0 &&
    tests
      .map((testSched) => {
        let test = testSched.summary;
        let condition = test && test.Condition ? test.Condition : " ";
        let comments = testSched.formData && testSched.formData.find((field) => field && field.id === "com");
        let flasherField = testSched.formData && testSched.formData.find((field) => field && field.id === "desc");
        let flashperMinField = testSched.formData && testSched.formData.find((field) => field && field.id === "flash");

        let data = arrayMethod(testSched);
        return data.length == 0 ? (
          <React.Fragment>
            <Col md={12} style={{ borderLeft: "1px solid #000", borderRight: "1px solid #000", borderTop: "1px solid #000" }}>
              <br />
              <div className="label-text">Flasher Test Results (FRA 234.253) Annual</div>
              <br />
            </Col>

            <Col md={7} style={{ borderLeft: "1px solid #000", borderBottom: "1px solid #000" }}>
              <div className="box-title" style={{ textAlign: "left" }}>
                Flasher Nomenclature
              </div>
            </Col>
            <Col md={5} style={{ borderRight: "1px solid #000", borderBottom: "1px solid #000" }}>
              <div className="box-title" style={{ textAlign: "left" }}>
                Flashes Per Minute
              </div>
            </Col>

            <React.Fragment>
              <Col md={7} style={{ borderLeft: "1px solid #000", padding: "5px 15px", borderBottom: "1px solid #000" }}>
                <div className="label-text">{flasherField ? flasherField.value : ""}</div>
                <div className="value-box">{condition}</div>
                <div className="comments-text info-section">{comments ? comments.value : ""}</div>
              </Col>

              <Col md={5} style={{ borderRight: "1px solid #000", padding: "5px 15px", borderBottom: "1px solid #000" }}>
                <Col md={6} className="border border-dark">
                  {flashperMinField ? flashperMinField.value : ""}
                </Col>
                <Col md={6}></Col>
                <br />
              </Col>
            </React.Fragment>
          </React.Fragment>
        ) : null;
      })
      .filter(Boolean);

  return returnData;
};



// WEBPACK FOOTER //
// ./src/components/Reports/CP/NewCrossingReport/ReportSections/genericTableSection.jsx